/**
 * Created by Bart Decorte
 * Date: 31/12/2020
 * Time: 10:28
 */
const EventEmitter = require('events');

export default class BrowserNotSupportedModal extends EventEmitter {
  constructor() {
    super();
    this.root = document.getElementById('modal-browser-support');

    if (!this.root) {
      throw new Error('Modal root not found.');
    }

    this.bindListeners();
  }

  bindListeners() {
    $(this.root).on('hide.bs.modal', e => {
      this.emit('hide');
    });
  }

  show() {
    $(this.root).modal('show');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modals/BrowserNotSupportedModal.js